import {createI18nScope} from './scope';

export default createI18nScope(`common.i18n`, {
  'time.less-than-minute-future': `in less than a minute`,
  'time.less-than-minute-past': `less than a minute ago`,
});
